<template>
		<div ref='chart' style="width:95%;height:500px"></div>
</template>

<script>
	const echarts = require('echarts');
	export default {
		created() {
			//this.OrderCusList = this.inordercuss;
			// this.ShowCharts()
		},
		data() {
			return {
				OrderCusList:this.inordercuss
			}
		},
		props: ['inordercuss'],
		mounted:function () {
		            this.$nextTick(function () {
		                this.ShowCharts();
		            });
},
		methods: {
			ShowCharts() {
				if (this.OrderCusList.length < 1)
					return;
					
				let nocheck = 0;
				let checked = 0;
				let rpted = 0;
				for (let i = 0; i < this.OrderCusList.length; i++) {
					if (this.OrderCusList[i].cusstatus < 50)
						nocheck++;
					else if (this.OrderCusList[i].cusstatus == 50)
						checked++;
					else
						rpted++;
				}
				let xvalue = ['未检', '已检', '已出报告'];
				let yvalue = [
				                {value: nocheck, name: '未检'},
				                {value: checked, name: '已检'},
				                {value: rpted, name: '已出报告'}
				            ];
							 var myChart = echarts.init(this.$refs.chart);
							// myChart.setOption({
							// 	title: {
							// 		text: '1'
							// 	},
							// 	tooltip: {},
							// 	xAxis: {
							// 		data: xvalue
							// 	},
							// 	yAxis: {},
							// 	series: [{
							// 		name: '2',
							// 		type: 'line',
							// 		data: yvalue
							// 	}]
							// });
				 
				myChart.setOption({
					title: {
						text: '体检人数统计'
					},
					tooltip: {},
					legend: {
						type: 'scroll',
						orient: 'vertical',
						right: 10,
						top: 20,
						bottom: 20,
						data: xvalue
					},
					series: [{
						name: '人数',
						type: 'pie',
						radius: '55%',
						center: ['40%', '50%'],
						data: yvalue,
						emphasis: {
							itemStyle: {
								shadowBlur: 10,
								shadowOffsetX: 0,
								shadowColor: 'rgba(0, 0, 0, 0.5)'
							}
						}
					}]
				});
			}
		}
	}
</script>

<style>
</style>
